import React, { Component } from "react";
import PropTypes from "prop-types";
import UIDatePicker from "react-datepicker";
import ActivityButton from "../ActivityButton/ActivityButton";
import "./DatePicker.css";
import "react-datepicker/dist/react-datepicker.css";
import calendarIcon from "../../../assets/images/icon-calendar.svg";
/**
 * @desc Datepicker
 * @param props
 * @return null
 */
const DatePicker = props => {
  const { className, ...other } = props;
  return (
    <div className={"ui-datepicker " + className}>
      <label>{props.label}</label>
      <span className="form-error-message">{props.children}</span>
      <ActivityButton icon={calendarIcon} position="right">
        <UIDatePicker {...other}>{props.children}</UIDatePicker>
      </ActivityButton>
    </div>
  );
};

DatePicker.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string
};

DatePicker.defaultProps = {
  className: "",
  label: "",
  value: ""
};

export default DatePicker;



// WEBPACK FOOTER //
// ./src/components/UI/DatePicker/DatePicker.js